import LocalStorage from '../../data/local-storage';
import AuthService from '../../services/auth-service';
import BookmarkService from '../../services/bookmark-service';
import NotificationService from '../../services/notification-service';

export default class ProfileModel {
  constructor() {
    this.isAuthenticated = false;
    this.user = {};
    this.currentTheme = 'light';
    this.currentFont = 'default';
    this.pushSubscription = null;
    this.bookmarks = [];
    this.notifications = [];
  }

  loadUserState() {
    const { isAuthenticated, user } = AuthService;
    this.isAuthenticated = isAuthenticated;
    this.user = user || {};

    if (isAuthenticated && user.id) {
      this.bookmarks = BookmarkService.getBookmarks();
      this.notifications = NotificationService.getNotifications();
      this.pushSubscription = LocalStorage.getUserSpecificObject(
        'heliaedu_user_push_subscription',
        user.id
      );
    } else {
      this.bookmarks = [];
      this.notifications = [];
      this.pushSubscription = null;
    }

    this.currentTheme = LocalStorage.getItem('heliaedu_theme') || 'light';
    this.currentFont = LocalStorage.getItem('heliaedu_font') || 'default';
  }

  getUserData() {
    return {
      isAuthenticated: this.isAuthenticated,
      user: this.user,
      bookmarkCount: this.bookmarks.length,
      notificationCount: this.notifications.length
    };
  }

  updateTheme(theme) {
    this.currentTheme = theme;
    LocalStorage.setItem('heliaedu_theme', theme);
    return true;
  }

  updateFont(font) {
    this.currentFont = font;
    LocalStorage.setItem('heliaedu_font', font);
    return true;
  }

  getCurrentTheme() {
    return this.currentTheme;
  }

  getCurrentFont() {
    return this.currentFont;
  }

  isPushSubscribed() {
    return !!this.pushSubscription;
  }

  setPushSubscription(subscription) {
    this.pushSubscription = subscription;
    
    if (this.isAuthenticated && this.user.id) {
      const key = LocalStorage.getUserSpecificKey(
        'heliaedu_user_push_subscription',
        this.user.id
      );
      if (subscription) {
        LocalStorage.setObject(key, subscription);
      } else {
        LocalStorage.removeItem(key);
      }
    }
  }

  logout() {
    LocalStorage.removeItem('heliaedu_token');
    LocalStorage.removeItem('heliaedu_user');
    
    this.isAuthenticated = false;
    this.user = {};
    this.bookmarks = [];
    this.notifications = [];
    this.pushSubscription = null;
    
    return true;
  }

  getProfileStats() {
    return {
      bookmarkCount: this.bookmarks.length,
      notificationCount: this.notifications.length,
      isPushSubscribed: this.isPushSubscribed()
    };
  }
}